import React, { useState,useEffect } from "react";
import { useSelector } from "react-redux";
import { WelcomePageButtonClick, WelcomePageView } from '../utils/Analytics';

function EnterName(props) {
  const appUserNameFromStore = useSelector((store) => store.layout.appUserName);
  const [name, setName] = useState(appUserNameFromStore);
  const [error, setError] = useState("");

  const handleName = (e) => {
    setName(e.target.value);
    setError("");
  };

  const submitName = (e) => {
    // e.preventDefault();
    if (name.trim() != "") {
      localStorage.setItem("appUserName", name);
      WelcomePageButtonClick();
      setTimeout(() => {
        props.hide();
      }, 700);
    } else {
      setError("validation");
    }
  };

  useEffect(() => {
    WelcomePageView();    
}, []);

  return (
    <div className="enter-name mt-10">
      <div className="welcome">Welcome</div>
      <div className="profile mt-2">Complete your profile</div>
      <form onSubmit={submitName} className="mt-5">
        <input
          value={name}
          type="text"
          className="p-3"
          placeholder="Enter Your Full Name"
          onChange={handleName}
        />
        <button className="submit mt-5">Submit</button>
      </form>
      {error === "validation" && (
        <div className="text-red-500 mt-3 text-center text-sm">
          Please Enter Your Name
        </div>
      )}
    </div>
  );
}

export default EnterName;
